import Task3 from './Task3';
export default Task3